import { z } from "zod";
import { lenientArray, strings, text } from "./common";

export const WEEK_TONES = ["good", "steady", "careful"] as const;
export type WeekTone = (typeof WEEK_TONES)[number];

export const weekAreaSchema = z.object({
  key: z.enum(["career", "money", "love", "health"]),
  title: text(),
  tone: z.enum(WEEK_TONES).catch("steady"),
  line: text(),
  do: text(),
  dont: text(),
  why: strings(),
});
export type WeekArea = Readonly<z.output<typeof weekAreaSchema>>;

/** One day of a week or month and how the tradition reads it, for the calendar. */
export const periodDaySchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  quality: z.enum(WEEK_TONES).catch("steady"),
});
export type PeriodDay = Readonly<z.output<typeof periodDaySchema>>;

/** `POST /chart/week-preview`: this week for a chart, before an account exists. */
export const weekSchema = z.object({
  week: z.object({ start: text(), end: text(), label: text() }),
  signs: z.object({ moon_sign: text(), moon_rashi: text(), lagna: text(), lagna_rashi: text() }),
  headline: text(),
  areas: lenientArray(weekAreaSchema),
  best_days: strings(),
  careful_days: strings(),
  days: lenientArray(periodDaySchema),
  written_by: text(),
});
export type WeekReading = Readonly<z.output<typeof weekSchema>>;
